﻿import { IQuote } from "../models";

export class KineticClient {
    constructor(private e: any) {
    }

    public updateExternalSalesOrder(
        company: string,
        custNum: number,
        orderNum: number,
        poNum: number,
        partNum: string,
        kbmaxConfiguredProductId: number,
        orderHed: any,
        orderDtl: any) {
        return this.e.kineticUpdateSalesOrder({ company: company, custNum: custNum, orderNum: orderNum, poNum: poNum, partNum: partNum, kbmaxConfiguredProductId: kbmaxConfiguredProductId, orderHed: orderHed, orderDtl: orderDtl}).then(resp => {
            if (resp.statusCode >= 200 && resp.statusCode < 400) {
                let body = JSON.parse(resp.body);
                if (body) body = body.parameters;
                if (body) body = body.ds;
                return body;
            }
            throw resp.body;
        });
    }

    public quoteToSalesOrder(
        quote: IQuote,
        company: string,
        custNum: number,
        orderNum: number,
        poNum: number) {
        return this.e.kineticQuoteToSalesOrder({
            quote: quote,
            company: company,
            custNum: custNum,
            orderNum: orderNum,
            poNum: poNum
        }).then(resp => {
            if (resp.statusCode >= 200 && resp.statusCode < 400) {
                let body = JSON.parse(resp.body);
                if (body) body = body.parameters;
                if (body) body = body.ds;
                return body;
            }
            throw resp.body;
        });
    }

    public attach(
        source,
        filePath,
        idQuote,
        idTag,
        idQuoteProduct,
        kineticDocumentType) {
        return this.e.attachFileToKinetic({
            source: source,
            filePath: filePath,
            idQuote: idQuote,
            idTag: idTag,
            idQuoteProduct: idQuoteProduct,
            kineticDocumentType: kineticDocumentType
        }).then(resp => {
            if (resp.statusCode >= 200 && resp.statusCode < 400) {
                let body = JSON.parse(resp.body);
                if (body) body = body.parameters;
                if (body) body = body.ds;
                return body;
            }
            throw resp.body;
        });
    }

    public attachMedia(
        mediaPath: string
    ) {
        return this.e.attachFileToKinetic({
            source: 0,
            filePath: mediaPath
        });
    }

    public attachByTag(
        idQuote: number,
        idTag: number
    ) {
        return this.e.attachFileToKinetic({
            source: 1,
            idQuote,
            idTag
        });
    }

    public attachQuoteProduct(
        idQuote: number,
        idTag: number,
        idQuoteProduct: number
    ) {
        return this.e.attachFileToKinetic({
            source: 1,
            idQuote,
            idTag,
            idQuoteProduct
        });
    }

    public apiCall(
        url: string,
        method: string,
        body: string,
        company: string) {
        return this.e.kineticApiCall({
            url: url,
            method: method,
            body: body,
            company: company
        });
    }
}